import hindi from "./hindi";
import english from "./english";
export const languages = {
    english,
    hindi
};
export const language = (lang="english")=>(
    (key,lan=lang)=>(lan=="english")?key:(languages[lan][key]||key)
)